import {ref, watch} from 'vue'
import {defineStore} from 'pinia'
import router from "@/router";
import {getChannel} from "@/plugins/utils";
import {getDomainChannel, webOpen} from "@/api/home";

export const useGlobalStore = defineStore('global', () => {
    const loading = ref(false)
    const promotion = ref({
        ChannelID: window.localStorage.getItem('channelID') ? parseInt(window.localStorage.getItem('channelID')) : 0,
        GameID: 0,
        PromoterID: window.localStorage.getItem('promoterID') ? parseInt(window.localStorage.getItem('promoterID')) : 0,
        otherID: 0
    })
    const siteSettings = ref({
        banner: "",
        url: "",
        giftCode: "",
        download: "",
        icp: "",
        mondrop: "",
        authorizationArr: []
    })
    const site = ref(1)

    const mergeSite = ref(JSON.parse(window.localStorage.getItem('mergeSite')) || {
        show: false,
        site: 0,
    })

    watch(() => mergeSite.value, () => {
        window.localStorage.setItem('mergeSite', JSON.stringify(mergeSite.value))
    }, {deep: true})

    watch(() => promotion.value, () => {
        window.localStorage.setItem('channelID', promotion.value.ChannelID)
        window.localStorage.setItem('promoterID', promotion.value.PromoterID)
    }, {deep: true})

    watch(() => site.value, (a, b) => {
        window.localStorage.setItem('site', site.value)
    })


    return {loading, promotion, siteSettings, site, mergeSite}
})

router.onReady(async () => {
    const globalStore = useGlobalStore()

    let pid = router.currentRoute.query["t"]
    if (pid) {
        globalStore.promotion.PromoterID = parseInt(pid)
    }

    let cid = router.currentRoute.query["c"]
    if (cid) {
        globalStore.promotion.ChannelID = parseInt(cid)
    }

    let site = router.currentRoute.query["site"]
    if (site) {
        globalStore.site = parseInt(site)
    }

    let merge = router.currentRoute.query["merge"]
    if (merge) {
        globalStore.mergeSite.site = merge
        globalStore.mergeSite.show = true
    }

    //启动上报
    webOpen({
        "referer": document.referrer,
    })

})
